module.exports = __webpack_public_path__ + "img/23.ddebc216.png";